import { classes } from "../../../omnia"
import { PlanContext } from "../../context"
import { ObservationsMgr } from "../../observations/manager"
import { SelectedFieldObservation } from "../../observations/types"
import { Action } from "./Action"
import { SaveFavorite } from "./SaveFavorite"
import { TextArea } from "./TextArea"

interface Props {

    obs: SelectedFieldObservation

    mgr: ObservationsMgr

}

export function Observation({ obs, mgr }: Props) {

    const { dispatch } = React.useContext(PlanContext)

    const isActive = mgr.isActive(obs.key) && (!obs.deleted)

    const setHasFocus = (hasFocus: boolean) => {
        if (hasFocus) {
            dispatch({ type: "selectObservation", observation: obs.key })
        }
    }

    const update = (text: string) => {
        dispatch({ type: "updateObservation", key: obs.key, text })
    }

    const toggleDelete = () => {
        dispatch({ type: "deleteObservation", key: obs.key, delete: !obs.deleted })
    }

    return <div className="obs-row">

        <div className={classes("obs", obs.deleted && "deleted", isActive && "active")}>

            <TextArea text={obs.text || ""} disabled={obs.deleted} setText={update} placeholder="Input or select an observation" active={isActive} setHasFocus={setHasFocus} />

            {
                isActive &&
                <SaveFavorite obs={obs} mgr={mgr} />
            }

            {
                (!obs.deleted) &&
                <button type="button" className="btn btn-icon delete" onClick={toggleDelete} title="Remove">
                    <i className="fas fa-trash-alt"></i>
                </button>
            }

            {
                (obs.deleted) &&
                <button type="button" className="btn btn-icon delete undo" onClick={toggleDelete} title="Undo">
                    <i className="fas fa-undo-alt"></i>
                </button>
            }

        </div>

        <div className={classes("actions", obs.deleted && "deleted")}>

            {obs.actions.map(a => <Action key={a.key} obs={obs} action={a} mgr={mgr} />)}

        </div>

    </div>

}
